const t = {
  name: "FoodAndBeverageFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1625_151)">
<path d="M4 10V2H2V10C2 11.6523 3.34772 13 5 13H6V22H8V13H9C10.6523 13 12 11.6523 12 10V2H10V10C10 10.5477 9.54772 11 9 11H5C4.45228 11 4 10.5477 4 10Z" fill="currentColor"/>
<path d="M8 9V2H6V9H8Z" fill="currentColor"/>
<path d="M15 8C15 4.68772 17.6877 2 21 2H22V22H20V17H18C16.3477 17 15 15.6523 15 14V8Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_1625_151">
<rect width="20" height="20" fill="white" transform="translate(2 2)"/>
</clipPath>
</defs>
</svg>
  `
};
export {
  t as FoodAndBeverageFilled
};
